import Load from 'components/Load';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

// tslint:disable space-in-parens
const AsyncWriteAReview = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/WriteAReviewContainer'
    ),
);

const AsyncWriteAReviewUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/WriteAReviewUnauthenticatedContainer'
    ),
);

const AsyncSuggestionsContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/SuggestionsContainer'
    ),
);
const AsyncFeedbackContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/FeedbackContainer'
    ),
);

const AsyncFeedbackUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/FeedbackUnauthenticatedContainer'
    ),
);

const AsyncSuggestionsUnauthenticatedContainer = Load(
  () =>
    import(
      /* webpackChunkName: "write-review" */ './containers/SuggestionsUnauthenticatedContainer'
    ),
);

// tslint:enable space-in-parens

const WriteReviewRoutes = [
  <NavigationableLayout
    key="review-suggestions"
    nonFixedNavbar
    path={`${basePath}/manage/review/:tripId/suggestions`}
    component={AsyncSuggestionsContainer}
    hideFooter
    showBottomNavigation
  />,
  <Route
    key="review-more-feedback"
    path={`${basePath}/manage/review/:tripId/feedback`}
    component={AsyncFeedbackContainer}
  />,
  <NavigationableLayout
    key="review-suggestions-unauthenticated"
    nonFixedNavbar
    path={`${basePath}/manage/review/:tripId/:accountId/suggestions`}
    component={AsyncSuggestionsUnauthenticatedContainer}
    hideFooter
    showBottomNavigation
  />,
  <Route
    key="review-more-feedback-unauthenticated"
    path={`${basePath}/manage/review/:tripId/:accountId/feedback`}
    component={AsyncFeedbackUnauthenticatedContainer}
  />,
  <Route
    key="write-a-review-unauthenticated"
    path={`${basePath}/manage/review/:tripId/:accountId`}
    component={AsyncWriteAReviewUnauthenticatedContainer}
  />,
  <Route
    key="write-a-review"
    path={`${basePath}/manage/review/:tripId`}
    component={AsyncWriteAReview}
  />,
];

export default WriteReviewRoutes;
